import Render from 'common/Render';
import _debug from 'debug';
import makeRoutes from './routes';
import { connectToReduxStore } from 'services/sse';

const debug = _debug('app::messaging');

export function index() {
  debug('Rendering messaging');

  Render.render(makeRoutes, connectToReduxStore);
}



// WEBPACK FOOTER //
// ./src/modules/messaging/index.js